import React, { useEffect, useState } from "react";
import { fetchBlogs } from "store/actions/blogActions";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Container, Row, Input, Label, Button } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import AppModal from "components/AppModal";
import DOMPurify from "dompurify";

const Blogs = () => {
  const dispatch = useDispatch();
  const { adminBlogs } = useSelector((state) => state.blog);
  const [category, setCategory] = useState("");
  const [year, setYear] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Lightbox state
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [lightboxAlt, setLightboxAlt] = useState("");

  const openLightbox = (src, alt) => {
    setLightboxSrc(src);
    setLightboxAlt(alt);
  };

  const closeLightbox = () => {
    setLightboxSrc(null);
    setLightboxAlt("");
  };

  // Close lightbox on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  const filteredBlogs = adminBlogs.filter((blog) => {
    const createdAtDate = new Date(blog.createdAt?.seconds * 1000);
    const createdAtYear = createdAtDate.getFullYear();

    return (
      (category ? blog.category === category : true) &&
      (year ? createdAtYear.toString() === year : true) &&
      (searchTerm
        ? blog.title.toLowerCase().includes(searchTerm.toLowerCase())
        : true)
    );
  });

  return (
    <>
      {/* Scoped styles for blog description images */}
      <style>{`
        .blog-description img {
          cursor: zoom-in;
          max-width: 100%;
          border-radius: 4px;
          transition: opacity 0.15s ease;
        }
        .blog-description img:hover {
          opacity: 0.85;
        }
      `}</style>

      {/* Image lightbox */}
      <AppModal
        isOpen={!!lightboxSrc}
        toggle={closeLightbox}
        type="image"
        src={lightboxSrc}
        alt={lightboxAlt}
        size="xl"
        centered
        closeLabel="Close"
      />
      <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
        <IoMdArrowBack /> Go Back
      </button>
      <Container className="my-3 px-4">
        <div className="my-4 text-center">
          <a
            href="https://youtu.be/b4XiHG5BnDM"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://youtu.be/b4XiHG5BnDM
          </a>
        </div>
        <h1 className="text-center my-4">FHP Updates & News</h1>
        <Row className="mb-4">
          <Col md={4}>
            <Label className="mr-2 mb-1">Category</Label>
            <Input
              type="select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select a category</option>
              <option value="who">Who</option>
              <option value="what">what</option>
              <option value="when">When</option>
              <option value="where">Where</option>
              <option value="why">Why</option>
              <option value="how">How</option>
              <option value="miscellaneo">Miscellaneo</option>
            </Input>
          </Col>
          <Col md={4}>
            <Label className="mr-2 mb-1">Year</Label>
            <Input
              type="select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">Select a year</option>
              <option value="2022">2022</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </Input>
          </Col>
          <Col md={4}>
            <Label className="mr-2 mb-1">Search</Label>
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by title"
            />
          </Col>
        </Row>
        <Row className="row-cols-1 row-cols-md-2 row-cols-xl-2 g-4 viewBlogs">
          {filteredBlogs.map((blog, index) => {
            const createdAtDate = new Date(blog.created_at?.seconds * 1000);
            const formattedCreatedAt = createdAtDate.toLocaleDateString();
            return (
              <Col key={index} className="my-2" md="12" xs="12">
                <Card className="p-3 m-2">
                  <Row>
                    <Col
                      md="2"
                      className="d-flex justify-content-center align-items-center"
                    >
                      <h5 className="m-0">{blog.category}</h5>
                    </Col>
                    <Col
                      md="2"
                      className="d-flex justify-content-center
    align-items-center"
                    >
                      {blog.imageUrl && (
                        <img
                          src={blog.imageUrl}
                          width={80}
                          height={80}
                          className="my-4"
                          style={{ cursor: "zoom-in", objectFit: "cover", borderRadius: "4px" }}
                          onClick={() => openLightbox(blog.imageUrl, blog.title)}
                          alt={blog.title}
                          title="Click to enlarge"
                        />
                      )}
                    </Col>
                    <Col md="8">
                      <h1>{blog.title}</h1>
                      <h3 className="text-muted">
                        Posted on: {formattedCreatedAt}
                      </h3>
                      <p
                        className="card-text blog-description"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.description) }}
                        onClick={(e) => {
                          if (e.target.tagName === "IMG") {
                            openLightbox(e.target.src, e.target.alt || blog.title);
                          }
                        }}
                        style={{ cursor: "default" }}
                      ></p>
                    </Col>
                  </Row>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
};

export default Blogs;
